import * as React from 'react';
import { TimeKeeperAssignment } from '../api/types/types';
const { Provider, Consumer } = React.createContext<TimeKeeperAssignment | null>(null);
export const TKProvider = Provider;
export const TKConsumer = Consumer;